export const en: Record<string, string> = {
  'communities.title': 'Communities',
  'communities.description': 'Manage community profiles, members, managers and groups.',
  'communities.create': 'New community',
  'communities.total': 'Communities',
  'communities.members': 'Members',
  'communities.groups': 'Groups',
  'communities.search': 'Search communities',
  'communities.searchPlaceholder': 'Name or description',
  'communities.empty': 'No communities yet. Create the first one.',
  'communities.noMatch': 'No communities match your search.',
  'communities.loadError': 'Could not load communities.',
  'communities.retry': 'Retry',
  'communities.open': 'Open community',
  'communities.back': 'All communities',
  'communities.dashboard': 'Community dashboard',
  'communities.profile': 'Community profile',
  'communities.name': 'Name',
  'communities.descriptionField': 'Description',
  'communities.descriptionPlaceholder': 'A short description of this community',
  'communities.type': 'Type',
  'communities.company': 'Company',
  'communities.municipality': 'Municipality',
  'communities.save': 'Save changes',
  'communities.saving': 'Saving…',
  'communities.managers': 'Managers',
  'communities.managersHint': 'Managers can access the community dashboard.',
  'communities.removeManager': 'Remove manager',
  'communities.noManagers': 'No managers assigned yet.',
  'communities.addManagers': 'Add managers',
  'communities.users': 'Members',
  'communities.noUsers': 'No members yet.',
  'communities.addUsers': 'Add members',
  'communities.groupsSection': 'Groups',
  'communities.noGroups': 'No groups yet.',
  'communities.groupPlaceholder': 'Group name',
  'communities.addGroup': 'Create group',
  'communities.groupCount': '{count} members',
  'communities.createTitle': 'Create community',
  'communities.createDescription': 'Set up a community. You can add members and managers afterwards.',
  'communities.cancel': 'Cancel',
  'communities.creating': 'Creating…',
  'communities.createAction': 'Create community',
  'communities.created': 'Community created',
  'communities.updated': 'Community updated',
  'communities.usersAdded': 'Members added',
  'communities.managersAdded': 'Managers added',
  'communities.managerRemoved': 'Manager removed',
  'communities.groupCreated': 'Group created',
  'communities.groupTitle': 'Group',
  'communities.groupDescription': 'Description',
  'communities.groupDescriptionPlaceholder': 'What is this group for?',
  'communities.saveDescription': 'Save description',
  'communities.descriptionSaved': 'Description saved',
  'communities.addGroupMembers': 'Add members',
  'communities.removeGroupMember': 'Remove',
  'communities.removeGroupMemberLabel': 'Remove {name} from group',
  'communities.removeGroupMemberConfirm': 'Remove {name} from this group?',
  'communities.removingGroupMember': 'Removing…',
  'communities.groupMemberRemoved': 'Member removed from group',
  'communities.removeGroupMemberError': 'Could not remove member from group.',
  'communities.notFound': 'Community or group not found.',
  'communities.activity': 'Community activity',
  'communities.period.week': 'Last 7 days',
  'communities.period.month': 'Month',
  'communities.totalCo2': 'CO₂ saved',
  'communities.totalRides': 'Rides offered',
  'communities.completed': 'Rides completed',
  'communities.occupancy': 'Average occupancy',
  'communities.ridesPerUser': 'Rides per member',
  'communities.moneyPerDay': 'Savings by day',
  'communities.totalMoney': 'Total savings',
  'communities.chartActivity': 'Rides and CO₂ saved',
  'communities.chartLegend': 'Bars: rides · Line: CO₂',
  'communities.loadDashboardError': 'Could not load community activity.',
  'communities.loading': 'Loading community…',
  'communities.type.COMPANY': 'Company',
  'communities.type.MUNICIPALITY': 'Municipality',
};

export const de: Record<string, string> = {
  'communities.title': 'Communities',
  'communities.description': 'Communities, Mitglieder, Manager und Gruppen verwalten.',
  'communities.create': 'Community erstellen',
  'communities.total': 'Communities',
  'communities.members': 'Mitglieder',
  'communities.groups': 'Gruppen',
  'communities.search': 'Communities suchen',
  'communities.searchPlaceholder': 'Name oder Beschreibung',
  'communities.empty': 'Noch keine Community vorhanden. Erstelle die erste.',
  'communities.noMatch': 'Keine passende Community gefunden.',
  'communities.loadError': 'Communities konnten nicht geladen werden.',
  'communities.retry': 'Erneut laden',
  'communities.open': 'Community öffnen',
  'communities.back': 'Alle Communities',
  'communities.dashboard': 'Community-Dashboard',
  'communities.profile': 'Community-Profil',
  'communities.name': 'Name',
  'communities.descriptionField': 'Beschreibung',
  'communities.descriptionPlaceholder': 'Kurze Beschreibung der Community',
  'communities.type': 'Typ',
  'communities.company': 'Unternehmen',
  'communities.municipality': 'Gemeinde',
  'communities.save': 'Änderungen speichern',
  'communities.saving': 'Wird gespeichert…',
  'communities.managers': 'Manager',
  'communities.managersHint': 'Manager können das Community-Dashboard aufrufen.',
  'communities.removeManager': 'Manager entfernen',
  'communities.noManagers': 'Noch keine Manager zugewiesen.',
  'communities.addManagers': 'Manager hinzufügen',
  'communities.users': 'Mitglieder',
  'communities.noUsers': 'Noch keine Mitglieder vorhanden.',
  'communities.addUsers': 'Mitglieder hinzufügen',
  'communities.groupsSection': 'Gruppen',
  'communities.noGroups': 'Noch keine Gruppen vorhanden.',
  'communities.groupPlaceholder': 'Gruppenname',
  'communities.addGroup': 'Gruppe erstellen',
  'communities.groupCount': '{count} Mitglieder',
  'communities.createTitle': 'Community erstellen',
  'communities.createDescription': 'Richte eine Community ein. Mitglieder und Manager kannst du später hinzufügen.',
  'communities.cancel': 'Abbrechen',
  'communities.creating': 'Wird erstellt…',
  'communities.createAction': 'Community erstellen',
  'communities.created': 'Community erstellt',
  'communities.updated': 'Community aktualisiert',
  'communities.usersAdded': 'Mitglieder hinzugefügt',
  'communities.managersAdded': 'Manager hinzugefügt',
  'communities.managerRemoved': 'Manager entfernt',
  'communities.groupCreated': 'Gruppe erstellt',
  'communities.groupTitle': 'Gruppe',
  'communities.groupDescription': 'Beschreibung',
  'communities.groupDescriptionPlaceholder': 'Wofür ist diese Gruppe gedacht?',
  'communities.saveDescription': 'Beschreibung speichern',
  'communities.descriptionSaved': 'Beschreibung gespeichert',
  'communities.addGroupMembers': 'Mitglieder hinzufügen',
  'communities.removeGroupMember': 'Entfernen',
  'communities.removeGroupMemberLabel': '{name} aus der Gruppe entfernen',
  'communities.removeGroupMemberConfirm': '{name} wirklich aus dieser Gruppe entfernen?',
  'communities.removingGroupMember': 'Wird entfernt…',
  'communities.groupMemberRemoved': 'Mitglied aus der Gruppe entfernt',
  'communities.removeGroupMemberError': 'Mitglied konnte nicht aus der Gruppe entfernt werden.',
  'communities.notFound': 'Community oder Gruppe nicht gefunden.',
  'communities.activity': 'Aktivität der Community',
  'communities.period.week': 'Letzte 7 Tage',
  'communities.period.month': 'Monat',
  'communities.totalCo2': 'CO₂ eingespart',
  'communities.totalRides': 'Angebotene Fahrten',
  'communities.completed': 'Abgeschlossene Fahrten',
  'communities.occupancy': 'Durchschnittliche Auslastung',
  'communities.ridesPerUser': 'Fahrten pro Mitglied',
  'communities.moneyPerDay': 'Ersparnis pro Tag',
  'communities.totalMoney': 'Ersparnis gesamt',
  'communities.chartActivity': 'Fahrten und CO₂-Ersparnis',
  'communities.chartLegend': 'Balken: Fahrten · Linie: CO₂',
  'communities.loadDashboardError': 'Community-Aktivität konnte nicht geladen werden.',
  'communities.loading': 'Community wird geladen…',
  'communities.type.COMPANY': 'Unternehmen',
  'communities.type.MUNICIPALITY': 'Gemeinde',
};
